import { TherapistPreferences } from "../Settings/tabs/TherapistPreferences";

const TherapistPreferencesForm = ({ showUser }) => {
  return <TherapistPreferences shownUserId={showUser._id} />;
};

export default TherapistPreferencesForm;
